import { Link } from 'react-router-dom';
import type { CaseItem } from '@/lib/caseTypes';
import SectionHeading from '@/components/base/SectionHeading';
import StatusBadge from '@/components/base/StatusBadge';

type Props = {
  items: CaseItem[];
};

const HotSection = ({ items }: Props) => {
  const [lead, ...rest] = items;

  return (
    <section id="hot" className="scroll-mt-24 border-b border-background-200 bg-background-50">
      <div className="layout-shell py-12 md:py-16">
        <SectionHeading
          eyebrow="Today's Spotlight"
          title="今日引爆"
          desc="过去 24 小时讨论度最高的爆料，以及它们目前最新的进展状态。"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="lg:col-span-7">
            <Link to={`/case/${lead.id}`} className="block h-56 w-full overflow-hidden rounded-lg border border-background-300/70 md:h-72">
              <img
                src={lead.cover}
                alt={`${lead.title} - 今日引爆配图`}
                title={`${lead.title} · 瓜田追踪`}
                className="h-full w-full object-cover object-top"
              />
            </Link>
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <StatusBadge status={lead.status} />
              <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">{lead.category}</span>
              <span className="text-xs text-foreground-500">{lead.handle}</span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              <Link to={`/case/${lead.id}`} className="transition-colors hover:text-primary-700">
                {lead.title}
              </Link>
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{lead.summary}</p>
          </article>

          <div className="lg:col-span-5">
            <ul className="divide-y divide-background-200 rounded-lg border border-background-300/70">
              {rest.map((item) => (
                <li key={item.id} className="group">
                  <Link to={`/case/${item.id}`} className="flex gap-4 p-4 transition-colors hover:bg-background-100">
                    <div className="h-20 w-24 flex-none overflow-hidden rounded-md border border-background-200">
                      <img
                        src={item.cover}
                        alt={`${item.title} - 追踪配图`}
                        title={`${item.title} · 瓜田追踪`}
                        className="h-full w-full object-cover object-top"
                      />
                    </div>
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <StatusBadge status={item.status} />
                        <span className="text-xs text-foreground-500">{item.category}</span>
                      </div>
                      <h3 className="mt-2 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                        {item.title}
                      </h3>
                      <p className="mt-1.5 text-xs text-foreground-500">更新于 {item.updatedAt}</p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HotSection;